import React, { useState } from 'react'
import "./StepsGuide.less"
import Image from "../Common/Image/Image";
export default function StepsGuide() {
    const [currentTab, setCurrentTab] = useState(0);
    const getImagePath=(index)=>`assets/StepsGuide/Image${index+1}.svg`;
    const data = [
        {
            title: "Set your retirement date",
            content: "You can start by setting a clear retirement date so you know how much time you have left to save.<br/> This will help you plan your pension accordingly."
        },
        {
            title: "Evaluate your Current Financial status",
            content: "Assess your current financial situation, including assets and liabilities, to understand how much more you need to save for your pension."
        },
        {
            title: "Define Retirement Goals",
            content: "Make sure to clearly define your retirement goals, including how much income you will need, how you want to spend your time, and future healthcare needs to save optimally."
        },
        {
            title: "Calculate Retirement Corpus",
            content: "Use a pension calculator to determine the amount of money you will need for retirement. This will help you understand how much you need to save and by when."
        },
        {
            title: "Choose Investment Options",
            content: "Once you have a clear idea of your retirement corpus, you can choose investment options that will help you reach your pension goal."
        },
        {
            title: "Monitor Investments",
            content: "Regularly monitor your investments to ensure you are on track with your savings. This will help you adjust your strategy if needed."
        }
    ]
    return (
        <div className="stepsguidemain">
            <h2 className='stepsguideheading'>Step-by-Step guide to plan your retirement</h2>
            <div className='stepsguidesubheading'>
                <div className='stepsguidecards'>
                    {data.map((item, index) => {
                        const isActive = index === currentTab;
                        return (
                            <div onClick={()=>{setCurrentTab(index)}} className={`stepsguidecard ${isActive && "active"}`} key={index}>
                                <div className={`stepsguideactivetab ${isActive && "active"}`}></div>
                                <Image src={getImagePath(index)} className='stepsguidecardimage'/>
                                <h3 className={`stepsguidecardtitle ${isActive && "active"} ${(index===1||index===3) && "extra"}`}>{item.title}</h3>
                            </div>
                        )
                    })}
                </div>
                <div className='stepsguidecontent'>
                    <h3 className='stepsguidecontentheading'>{data[currentTab]?.title}</h3>
                    <div className='stepsguidecontentbody' dangerouslySetInnerHTML={{__html:data[currentTab]?.content}}></div>
                </div>
            </div>
        </div>
    )
}
